import Button from 'components/Button/index'
import Flex from 'components/Flex'
import Group from 'components/Images/Group.png'
import { Heading, Para } from 'modules/Drives/ViewDrive/Style/style'
import React from 'react'
import { useNavigate } from 'react-router-dom'
import {
  ConfromText,
  Content,
  DriveButton,
  ImageCenter,
  SpanText,
} from '../../../Style/style'

const AddUserForm = ({
  appliedCandidatesListTrue,
  singleRoleData,
  jobId,
  excandidateId,
}) => {
  const navigate = useNavigate()
  const onNavgateClick = () => {
    navigate(`/expcandidates/${excandidateId}/role/${jobId}`)
  }
  return (
    <Content alignCenter column center>
      <ImageCenter>
        <img src={Group} alt="groupImage" />
      </ImageCenter>
      <Flex column>
        <Heading center>
          {appliedCandidatesListTrue?.count > 1
            ? appliedCandidatesListTrue?.result?.length + ' candidates '
            : appliedCandidatesListTrue?.result?.length + ' candidate '}
          Shortlisted Successfully.
        </Heading>
        <ConfromText>
          <SpanText>
            {appliedCandidatesListTrue?.count > 1
              ? appliedCandidatesListTrue?.result?.length + ' candidates '
              : appliedCandidatesListTrue?.result?.length + ' candidate '}
          </SpanText>
          has been successfully shortlisted for{' '}
          <SpanText>{singleRoleData?.tittle}</SpanText>
        </ConfromText>
      </Flex>
      <Flex column>
        <Heading center style={{ paddingTop: '20px' }}>
          To see all the shortlisted candidates and schedule interview go to.
        </Heading>
        <Para center>
          Drives {'->'} Exp-Candidates{'->'} Role
        </Para>
      </Flex>
      <DriveButton>
        <Button.Secondary
          text="Go to Drive"
          height="38px"
          onClick={onNavgateClick}
        />
      </DriveButton>
    </Content>
  )
}

export default AddUserForm
